import { useEffect, useState } from "react";
import { Link, useHistory } from "react-router-dom";
import Button from "../../../../components/Button";
import IconButton from "../../../../components/IconButton";
import { IconEmail, IconLeftArrowVersion2 } from "../../../../icons";
import "./index.scss";

export const SuccessRecoverPassword = ({ email, handleRecoverPassword }) => {
  const [time, setTime] = useState(120);
  const history = useHistory();

  useEffect(() => {
    setTimeout(() => {
      if (time > 0) setTime((oldTime) => oldTime - 1);
      if (!time) history.push("/login");
    }, 1000);
  }, [time]);

  const hours = String(Math.floor(time / 60))?.padStart(2, "0");
  const minutes = String(time % 60)?.padStart(2, "0");

  return (
    <>
      <div className="progress-redirect bg-blue-100 text-primary font-familyPoppins text-sm px-2 py-1 rounded-xl">
        <p>
          Você será redirecionado em{" "}
          <span className="text-base font-semibold -mb-2">
            {hours}:{minutes}
          </span>
        </p>
      </div>
      <div className="flex flex-col items-center w-3/5 sm:w-4/5">
        <IconButton icon={IconEmail} className="icon-recoverPassword icon-mail" />
        <div className="box-icon-key flex justify-center items-center"></div>
        <div className="box-pulse flex justify-center items-center"></div>
        <h1 className="text-5xl font-semibold">Pronto.</h1>
        <p className="text-1.6rem mt-5 text-textPrimary text-center">Enviamos um link de recuperação de senha para {email}</p>
      </div>
      <div className="flex flex-col w-full gap-6 px-4">
        <span className="text-center font-familyPoppins text-textPrimary text-1.4rem">
          Não recebeu o e-mail?{" "}
          <span onClick={handleRecoverPassword} className="text-primary cursor-pointer hover:underline">
            {" "}
            Clique aqui para receber um novo e-mail
          </span>
        </span>
        <div className="w-full flex justify-center">
          <Link to="/login" className="w-3/5 sm:w-4/5 h-full">
            <Button className="w-full text-textPrimary hover:bg-gray-100 rounded-xl">
              <IconButton className="icon-back-login" icon={IconLeftArrowVersion2} /> Voltar para login
            </Button>
          </Link>
        </div>
      </div>
    </>
  );
};
